import { render, staticRenderFns } from "./LoadingSupervisionContractRecord.vue?vue&type=template&id=66524092&scoped=true"
import script from "./LoadingSupervisionContractRecord.vue?vue&type=script&lang=js"
export * from "./LoadingSupervisionContractRecord.vue?vue&type=script&lang=js"
import style0 from "./LoadingSupervisionContractRecord.vue?vue&type=style&index=0&id=66524092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66524092",
  null
  
)

export default component.exports